import { createFileRoute } from '@tanstack/react-router';
import { DocumentPage } from '../../features/documents';

export const Route = createFileRoute('/portal/documents/$id')({
  component: function DocumentRoute() {
    const { id } = Route.useParams();
    return <DocumentPage id={id} />;
  },
});
